import React from 'react';
import SubNav from '../SubNav/SubNav';

function TechDetails ()
{
    return (
        <div>
            <SubNav/>
            Technical Details
        </div>
    )
}

export default TechDetails;


// WEBPACK FOOTER //
// ./src/components/Tech-details/Tech-details.js